const ITEMS = [
  ["Mémorisation", "ٱلْحِفْظ"],
  ["Révision", "ٱلْمُرَاجَعَة"],
  ["Régularité", "ٱلثَّبَات"],
  ["Intention", "ٱلنِّيَّة"],
  ["6 mois de plan", "ٱلْقُرْآن"],
  ["30 jours de révision", "ٱلتَّدَبُّر"],
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="marquee" aria-hidden="true" data-testid="editorial-marquee">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div className="marquee-half" key={half}>
            {row.map(([fr, ar], i) => (
              <span className="mq-item" key={`${half}-${i}`}>
                <span className="mq-fr">{fr}</span>
                <i className="mq-dot" />
                <span className="mq-ar">{ar}</span>
                <i className="mq-dot" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
